var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-5"},[_c('login',{staticClass:"col-12 col-lg-6 offset-lg-3 w-100"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }